import { render, staticRenderFns } from "./RerConfig.vue?vue&type=template&id=1c922fc2&scoped=true"
import script from "./RerConfig.vue?vue&type=script&lang=js"
export * from "./RerConfig.vue?vue&type=script&lang=js"
import style0 from "./RerConfig.vue?vue&type=style&index=0&id=1c922fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c922fc2",
  null
  
)

export default component.exports